module.exports = __webpack_public_path__ + "static/img/dlogo.bcfa562.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dlogo.png
// module id = LwjX
// module chunks = 12